<template>
  <div id="LEManagement">
    <div class="switch_role">
      <div class="button_group">
        <span
          class="c_p t_c"
          :class="agent==1 ? 'active' : ''"
          @click="agent = 1"
        >{{$t('common.LEManagement')}}</span>
        <span
          class="c_p t_c"
          :class="agent==2 ? 'active' : ''"
          @click="agent = 2"
        >{{$t('common.LEUpload')}}</span>
      </div>
    </div>
    <div class="mainFixed" style="position:relative;top:0;width:calc(100% - 20px);">
      <div v-if="agent==2" class="allSearch d_flex" style="padding-top: 0;">
        <dl></dl>
        <dl>
          <dt>
            <button class="cancelButtonRed m_l_10" @click="downloadTemplate">{{$t('common.UploadTemplate')}}</button>
            <label><button class="redButton m_l_10" @click="uploadLEBtn">{{$t('common.Upload')}}</button>
            <input type="file" class="uploadExcel" accept=".xls,.xlsx" id="importExcel" onclick="this.value=null" @change="uploadLE" /></label>
          </dt>
        </dl>
      </div>
      <table v-if="agent==1" class="allTable" cellspacing="0">
        <thead>
          <tr>
            <td>Scenario</td>
            <td>{{$t('common.Show')}}</td>
            <td>{{$t('common.Operator')}}</td>
            <td>{{$t('common.OperationDate')}}</td>
          </tr>
        </thead>
        <tbody>
        <tr v-if="scenarioList && scenarioList.length>0" v-for="(item,index) in scenarioList" :key="index">
          <td>{{item.Scenario}}</td>
          <td>
            <input type="checkbox" class="allSwitch" :id="'Scenario' + index" v-model="item.Active" @change="isScenarioChange(item.Id, item.Active)">
            <label :for="'Scenario' + index"></label>
          </td>
          <td>{{item.ModifiedBy}}</td>
          <td>{{item.ModifiedTime}}</td>
        </tr>
        <tr v-else>
          <th colspan="4">{{$t('common.noData')}}</th>
        </tr>
        </tbody>
      </table>
      <table v-if="agent==2" class="allTable" cellspacing="0">
        <thead>
        <tr>
          <td>Scenario</td>
          <td>{{$t('common.View')}}</td>
          <td>{{$t('common.Operator')}}</td>
          <td>{{$t('common.OperationDate')}}</td>
        </tr>
        </thead>
        <tbody>
        <tr v-if="scenarioUploadList && scenarioUploadList.length>0" v-for="(item,index) in scenarioUploadList" :key="index">
          <td>{{item.Scenario}}</td>
          <td><a class="colorRed" @click="downloadLE(item.Scenario)">{{$t('common.Download')}}</a></td>
          <td>{{item.ModifiedBy}}</td>
          <td>{{item.ModifiedTime}}</td>
        </tr>
        <tr v-else>
          <th colspan="4">{{$t('common.noData')}}</th>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      agent: 1,
      scenarioList: false,
      scenarioUploadList: false
    }
  },
  beforeCreate () {
    this.$parent.topName = this.$t('common.LEManagement')
  },
  created () {
    this.getScenarioList()
    this.getScenarioUploadList()
  },
  mounted () {
    document.getElementById('index').addEventListener('click', closeMenu)
  },
  destroyed () {
    document.getElementById('index').removeEventListener('click', closeMenu)
  },
  methods: {
    getScenarioList () {
      this.$axiox.get('/api/v1/admin/scenarioConfig/list').then(res => {
        this.scenarioList = res.data
      })
    },
    getScenarioUploadList () {
      this.$axiox.get('/api/v1/admin/scenarioConfig/le/list').then(res => {
        this.scenarioUploadList = res.data
      })
    },
    isScenarioChange (id, active) {
      this.$axiox.put('/api/v1/admin/scenarioConfig', {Id: id, Active: active}).then(res => {
        this.getScenarioList()
      })
    },
    downloadLE (val) {
      this.$axiox.get('/api/v1/admin/scenarioConfig/le/download?version=' + val).then(res => {
        location.href = res.data.FileURL
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.ExportSuccess'),
          stayTime: 5
        })
      })
    },
    downloadTemplate () {
      this.$axiox.get('/api/v1/admin/scenarioConfig/le/template').then(res => {
        location.href = res.data.FileURL
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.ExportSuccess'),
          stayTime: 5
        })
      })
    },
    uploadLEBtn () {
      document.getElementById('importExcel').click()
    },
    uploadLE (type) {
      console.log(type.target.files)
      let files = type.target.files || []
      if (files.length > 0) {
        let fileFormData = new FormData()
        fileFormData.append('file', files[0])
        this.$axiox.upLoad('/api/v1/admin/scenarioConfig/le/upload', fileFormData).then(res => {
          if (res.success) {
            this.getScenarioUploadList()
            this.$commonJs.alertTips({
              type: 'success',
              content: this.$t('common.UploadSuccess'),
              stayTime: 5
            })
          } else {
            this.$commonJs.alertTips({
              type: 'error',
              content: res.message || this.$t('common.EditFailed'),
              stayTime: 5
            })
          }
        })
      }
    }
  }
}
function closeMenu () {}
</script>
<style scoped>
  #LEManagement th {
    text-align: center;
    padding: 10px;
    font-size: 12px;
    font-weight: normal;
  }
  #LEManagement .allTable thead td {
    border-bottom: 2px solid #d68497;
  }
  #LEManagement .allTable td {
    padding: 0.8% 0 0.8% 2%;
    vertical-align: inherit;
  }
  #LEManagement .allTable {
    width: 100%;
  }
  #LEManagement .allTable tbody tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  #LEManagement .mainFixed {
    padding: 10px;
    margin-bottom: 10px;
  }
  .switch_role {
    display: flex;
    margin-top: 10px;
    padding-right: 10px;
    justify-content: space-between;
    align-items: center;
  }
  .button_group {
    font-size: 0;
  }
  .button_group span {
    display: inline-block;
    padding: 8px 0;
    width: 130px;
    color: #c50f3c;
    background-color: white;
    border: 1px solid #c50f3c;
    font-size: 12px;
    font-weight: 600;
  }
  .button_group span:nth-child(1) {
    border-top-left-radius: 6px;
  }
  .button_group span:nth-child(2) {
    border-top-right-radius: 6px;
  }
  .active {
    color: white !important;
    background-color: #c50f3c !important;
  }
  .uploadExcel{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/gileadSales/LEManagement.vue